import { forwardRef, MutableRefObject } from 'react'
import { ModalDialog } from '../ModalDialog/ModalDialog'
import { useObjectRef } from '../../utils/useObjectRef'
import { FormWithSubmit } from './FormWithSubmit'
import { Button } from '../Button/Button'
import Styles from './FormModal.module.scss'
import { FormRef } from '../Form/Form'
import { ErrorProfileCard } from '../UserProfileCard/ErrorProfileCard'

interface Props {
  memberId?: number
  workspaceId: number
  onClose: () => void
  onComplete: () => void
}

export const FormModal = forwardRef<FormRef, Props>(({ memberId, workspaceId, onClose, onComplete }: Props, ref) => {
  const submitButtonContainer = useObjectRef<HTMLDivElement>()

  return (
    <ModalDialog
      onClose={onClose}
      title="Profile"
      footer={
        <>
          <Button size="md" variant="tertiary" onPress={onClose}>
            Cancel
          </Button>
          <div className={Styles.submitButton} ref={submitButtonContainer} />
        </>
      }
    >
      {!memberId && <ErrorProfileCard />}
      {memberId && (
        <FormWithSubmit
          ref={ref}
          workspaceId={workspaceId}
          memberId={memberId}
          submitButtonContainer={submitButtonContainer as MutableRefObject<HTMLDivElement>}
          onComplete={onComplete}
        />
      )}
    </ModalDialog>
  )
})
